module.exports = __webpack_public_path__ + "static/media/CircleWarning.c0738c17.svg";